<style scoped lang="scss">

</style>

<template>
  <transition
    name="custom-classes-transition"
    enter-active-class="animated fadeInDown"
    leave-active-class="animated fadeOutDown"
  >
    <b-alert
      class="mx-2 my-2"
      :show="dismissCountDown"
      dismissible
      fade
      :variant="msg.type"
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
    >
      <p>{{ msg.content }}</p>
      <b-progress
        v-show="msg.isProgressBar"
        variant="warning"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      />
    </b-alert>
  </transition>
</template>

<script>
// import store, { REMOVE_GLOBAL_MESSAGE } from '@/store'
export default {
  props: {
    index: {
      type: Number
    },
    msg: {
      type: Object
    }
  },
  components: {

  },
  data () {
    return {
      /* Message ctrl */
      dismissSecs: 10,
      dismissCountDown: 10
    }
  },
  computed: {

  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    }
  },
  watch: {
    // dismissCountDown: function (current, previous) {
    //   if (current === 0) {
    //     store.commit(REMOVE_GLOBAL_MESSAGE, this.index)
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Messenger.vue